import { MeRepository } from 'common/repositories/index';

angular.module('controllers')
    .controller(
        'Applockplus',
        (
            $scope, $rootScope, $stateParams, $timeout, $state, $focus,
            $interval, $translate, Util, DeviceRestService,
        ) => {

            $scope.userId = MeRepository.getMyId();
            $scope.deviceId = $stateParams.deviceId;

            /**
         * The user confirmed locking this device
         */
            $scope.confirmStopManage = () => {

            /**
             * if the device is locked, 'applockplus' from the others.managed property
             * must be deleted
             */
            // TODO
            // var managed = Device.getManaged($scope.userId, $scope.deviceId);
                const managed = []; // TODO this var
                const managedParam = _.without(managed, 'applockplus');

                /* send the REST */
                const devicePayload = {
                    data: {
                        attributes: {
                            others: {
                                managed: _.isEmpty(managedParam) ? undefined : managedParam,
                            },
                        },
                        type: 'devices',
                        id: $scope.deviceId,
                    },
                };

                DeviceRestService.update($scope.deviceId, devicePayload);

                /* close the drilldown and go to the dashboard */
                $state.go('root.dashboard.home');

            };

        },

    );



// WEBPACK FOOTER //
// ./scripts/controllers/modals/applockplus.js